import React from "react";

import icon_Main from "../../../assets/svgs/MG/Vehiculo.svg";
import icon_Color from "../../../assets/svgs/MG/Color.svg";
import icon_Scenario from "../../../assets/svgs/MG/Escenarios.svg";
//import icon_Seat from "../../../assets/svgs/MG/Seat.svg";
import icon_Gallery from "../../../assets/svgs/MG/Galería.svg";
import icon_Ficha from "../../../assets/svgs/MG/ficha-tecnica.svg";
import icon_Cotiza from "../../../assets/svgs/MG/cotizacion.svg";
import { FichasData } from "../../../data/fichas.data";

interface Props {
  car: any;
  isInternalView: boolean;
  menu: string;
  setMenu: (value: string) => void;
}

const BottombarMain: React.FC<Props> = ({ car, isInternalView, menu, setMenu}) => {

  const [ficha, setFicha] = React.useState<any>(null);
  React.useEffect(() => {
    if(car){
      const fichasData: any = FichasData();
      setFicha(fichasData[car.id]);
    }
  }, [car]);

  const openURL = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };
  
  return (
      <div className={`bottombar-main-container`}>
        <div className={`bottombar-main-container-scroll`}>
          <div className={`bottombar-main-button ${menu === 'Main' ? 'selected':''}`} onClick={() => setMenu('Main')}>
            <img className={`bottombar-main-button-logo`} src={icon_Main} draggable={false} alt=''/>
            <div className={`bottombar-main-button-text ${!isInternalView ? 'selected':''}`}>Vehículo</div>
          </div>
          {isInternalView === false && <div className={`bottombar-main-button ${menu === 'Color' ? 'selected':''}`} onClick={() => setMenu('Color')}>
            <img className={`bottombar-main-button-logo`} src={icon_Color} draggable={false} alt=''/>
            <div className={`bottombar-main-button-text ${!isInternalView ? 'selected':''}`}>Color</div>
          </div>}
          {isInternalView === false && <div className={`bottombar-main-button ${menu === 'Scenario' ? 'selected':''}`} onClick={() => setMenu('Scenario')}>
            <img className={`bottombar-main-button-logo`} src={icon_Scenario} draggable={false} alt=''/>
            <div className={`bottombar-main-button-text ${!isInternalView ? 'selected':''}`}>Escenarios</div>
          </div>}
          {/* {isInternalView === true && <div className={`bottombar-main-button ${menu === 'Seat' ? 'selected':''}`} onClick={() => setMenu('Seat')}>
            <img className={`bottombar-main-button-logo`} src={icon_Seat} draggable={false} alt=''/>
            <div className={`bottombar-main-button-text ${!isInternalView ? 'selected':''}`}>Asientos</div>
          </div>} */}
          <div className={`bottombar-main-button ${menu === 'Options' ? 'selected':''}`} onClick={() => setMenu('Gallery')}>
            <img className={`bottombar-main-button-logo`} src={icon_Gallery} draggable={false} alt=''/>
            <div className={`bottombar-main-button-text ${!isInternalView ? 'selected':''}`}>Galería</div>
          </div>
          <div className={`bottombar-main-button ${menu === 'NA' ? 'selected':''}`} onClick={() => openURL(ficha.url_catalog)}>
            <img className={`bottombar-main-button-logo`} src={icon_Ficha} draggable={false} alt=''/>
            <div className={`bottombar-main-button-text ${!isInternalView ? 'selected':''}`}>Ficha</div>
          </div>
          <div className={`bottombar-main-button ${menu === 'NA' ? 'selected':''}`} onClick={() => openURL(ficha.url_cotiza)}>
            <img className={`bottombar-main-button-logo`} src={icon_Cotiza} draggable={false} alt=''/>
            <div className={`bottombar-main-button-text ${!isInternalView ? 'selected':''}`}>Cotiza</div>
          </div>
        </div>
      </div>
  );
};

export default BottombarMain;